var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 35,
    viewBox: "0 0 30 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.068 33.6375C11.8678 34.1522 12.1228 34.7317 12.6376 34.9319C13.1523 35.1321 13.7318 34.8771 13.932 34.3623L12.068 33.6375ZM28.5299 11.848L29.3779 11.318L28.3179 9.62201L27.4699 10.152L28.5299 11.848ZM13 33.9999L13.932 34.3623C15.0822 31.4046 17.2094 26.7048 19.836 22.2586C22.4875 17.7701 25.5515 13.7095 28.5299 11.848L27.9999 11L27.4699 10.152C24.0484 12.2905 20.7791 16.7298 18.114 21.2413C15.4239 25.7951 13.2511 30.5952 12.068 33.6375L13 33.9999Z",
    fill: "#07862B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.88656 19.7349C0.337643 19.7958 -0.0579827 20.2901 0.00290344 20.839C0.0637887 21.388 0.558131 21.7836 1.10705 21.7227L0.88656 19.7349ZM24.4811 6.49914L23.7981 5.76866C21.48 7.93595 17.5264 11.2501 13.2328 14.1192C8.89835 17.0156 4.37749 19.3477 0.88656 19.7349L0.996804 20.7288L1.10705 21.7227C5.11727 21.2779 9.98723 18.6934 14.344 15.7821C18.7415 12.8436 22.7795 9.45887 25.164 7.22961L24.4811 6.49914Z",
    fill: "#07862B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeft);
export default __webpack_public_path__ + "static/media/icon-left.51de703a9b1c815bf4924829303e220e.svg";
export { ForwardRef as ReactComponent };